// import RepositoryFactory from "@/apis";
// const PushNotification = RepositoryFactory.pushNotification;
import PushNotification from "../../apis/pushNotification";

export default {
  createNotification({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await PushNotification.create_notification(payload);
        // commit("CREATE_NOTIFICATION", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getAllNotification({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await PushNotification.get_all_notification(payload);
        commit("GET_ALL_NOTIFICATION", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteNotification({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await PushNotification.delete_notification(payload);
        // commit("DELETE_NOTIFICATION", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
